import {
    Component,
    OnInit,
    OnDestroy,
    computed,
    effect,
    ChangeDetectionStrategy
} from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { UsersService } from '../users-service/users.service';
import { MatButton } from '@angular/material/button';
import { RouterLink, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import {
    MatSlideToggleChange,
    MatSlideToggleModule
} from '@angular/material/slide-toggle';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BufferProgressBarComponent } from '../../../ui-components/buffer-progress-bar/buffer-progress-bar.component';
import { UserGroupDto } from '../../../protos/generated/admin.pb';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-user-groups',
    standalone: true,
    imports: [
        MatCardModule,
        MatButton,
        RouterLink,
        MatSlideToggleModule,
        MatTooltipModule,
        BufferProgressBarComponent,
        TranslatePipe
    ],
    templateUrl: './user-groups.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './user-groups.component.scss'
})
export class UserGroupsComponent implements OnInit, OnDestroy {
    userGroups: UserGroupDto[] = [];
    private subscription = new Subscription();
    isLoading = computed(() => this.usersService.userGroupsLoading());

    constructor(
        private usersService: UsersService,
        private dialog: MatDialog,
        private route: ActivatedRoute
    ) {
        effect(() => {
            if (this.usersService.getIsUserGroupChanged()()) {
                this.fetchGroups();
                this.usersService.getIsUserGroupChanged().set(false);
            }
        });
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe((params: any) => {
            if (params['updated']) {
                this.fetchGroups();
            }
        });
        this.subscription.add(
            this.usersService.getAllUserGroups().subscribe(res => {
                this.userGroups = res.userGroups;
            })
        );
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }

    fetchGroups(): void {
        this.subscription.add(
            this.usersService.getAllUserGroups().subscribe(res => {
                this.userGroups = res.userGroups ?? [];
            })
        );
    }

    onToggle(event: MatSlideToggleChange, userGroup: UserGroupDto): void {
        event.source.checked = !userGroup.disabled;
        const buttonElement = document.activeElement as HTMLElement;
        buttonElement?.blur();

        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: userGroup
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                event.source.checked = !userGroup.disabled;
            }
        });
    }
}
